"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CaptureBar = void 0;
const core_api_1 = require("@ikegps/core-api");
const core_shared_1 = require("@ikegps/core-shared");
const theme_1 = require("../../components/theme");
const mithril_1 = require("../../mithril");
const services_1 = require("../../services");
const page_state_1 = require("../../state/page.state");
const capture_thumbnail_1 = require("../capture.thumbnail/capture.thumbnail");
const capture_bar_style_1 = require("./capture.bar.style");
(0, theme_1.addStyles)(capture_bar_style_1.Style);
exports.CaptureBar = {
    view(collection) {
        if (collection == null) {
            return (0, mithril_1.m)('div', { className: capture_bar_style_1.CSS.container });
        }
        const seen = {};
        // We use these three arrays here to ensure a consistent order of photos when rendering
        const ikePhotos = [];
        const tagPhotos = [];
        const otherPhotos = [];
        collection.forEachField((field) => {
            let isIkePhoto = false;
            let photoBucket;
            if (core_shared_1.CollectionModelFieldTrueSize.isTrueSizeField(field)) {
                photoBucket = ikePhotos;
                isIkePhoto = true;
            }
            else if (core_shared_1.CollectionModelFieldImage.isImageField(field)) {
                photoBucket = tagPhotos;
            }
            else if (services_1.Services.Token.has(core_api_1.IkeToken.FEATURE_DISPLAY_ALL_PHOTOS) &&
                (core_shared_1.CollectionModelFieldHeight.isHeightField(field) ||
                    core_shared_1.CollectionModelFieldAnchor.isAnchorField(field) ||
                    core_shared_1.CollectionModelFieldNumber.isNumberField(field) ||
                    core_shared_1.CollectionModelFieldLocation.isLocationField(field) ||
                    core_shared_1.CollectionModelFieldVector.isVectorField(field))) {
                photoBucket = otherPhotos;
            }
            else {
                return;
            }
            const captures = field.getOwnedCaptures() || [];
            captures.sort((a, b) => {
                if (a.collectedAt.iso < b.collectedAt.iso) {
                    return 1;
                }
                if (a.collectedAt.iso > b.collectedAt.iso) {
                    return -1;
                }
                return 0;
            });
            for (const capture of captures) {
                if (!seen[capture.objectId]) {
                    const title = `${field.schema.displayName} - ${services_1.Services.DateTime.formatDateTime(capture.collectedAt.iso)}`;
                    seen[capture.objectId] = true;
                    const thumbnail = capture_thumbnail_1.CaptureThumbnail.view(collection, capture, {
                        truesize: capture.type === core_api_1.IkeCaptureType.TRUE_SIZE,
                        title,
                        selected: page_state_1.CurrentState.inspectedCaptureId === capture.objectId,
                        action: () => page_state_1.CurrentState.setInspectedCollection(page_state_1.CurrentState.inspectedCollectionRevision, capture.objectId),
                        icon: isIkePhoto,
                        size: capture_bar_style_1.THUMBNAIL_SIZE,
                    });
                    photoBucket.push(thumbnail);
                }
            }
        });
        return (0, mithril_1.m)('div', { className: capture_bar_style_1.CSS.container }, ikePhotos.concat(tagPhotos, otherPhotos));
    },
};
//# sourceMappingURL=capture.bar.js.map